export const ORANGE_MONEY = 'OrangeMoney';
export const AIRTEL = 'Airtel';
export const VODACOM = 'Vodacom';
export const AFRICEL = 'Africacell';
export const EQUITY = 'Equity';
export const ECOBANK = 'Ecobank';
export const UNIPESA_SIMULATOR = 'Unipesa Simulator';

export const PHONE_NUMBER_REGEXP = /^254[0-9]{9}$/;
export const PHONE_NUMBER_WITHOUT_CODE_REGEXP = /^[0-9]{10}$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ACCOUNT_NUMBER_LENGTH = 11;
export const AMOUNT_FIELD_NAME = 'amount';

export const TYPE_DROPDOWN = 'dropdown';

export const DEPOSIT_CONFIG = {
  [ORANGE_MONEY]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^0\d{9}$/,
    },
  },
  [AIRTEL]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^[1-9]\d{8}$/,
    },
  },
  [VODACOM]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^243\d{9}$/,
    },
  },
  [AFRICEL]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^0\d{9}$/,
    },
  },
  [EQUITY]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
  [ECOBANK]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
  [UNIPESA_SIMULATOR]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
};

export const WITHDRAW_CONFIG = {
  [ORANGE_MONEY]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^0\d{9}$/,
    },
  },
  [AIRTEL]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^[1-9]\d{8}$/,
    },
  },
  [VODACOM]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^243\d{9}$/,
    },
  },
  [AFRICEL]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {
      regexp: /^0\d{9}$/,
    },
  },
  [EQUITY]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
  [ECOBANK]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
  [UNIPESA_SIMULATOR]: {
    [AMOUNT_FIELD_NAME]: {},
    customer_id: {},
  },
};
